import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initAppAction, selectApp } from '@store/app';
import { Widget } from '@modules/widget';
import { AppInitProps } from './types';

export const AppInit = ({ children, locale, apiPrefix }: AppInitProps) => {
    const dispatch = useDispatch();
    const { isAppInit } = useSelector(selectApp);

    useEffect(() => {
        dispatch(initAppAction({ locale, apiPrefix }));
    }, [dispatch, locale, apiPrefix]);

    if (!isAppInit) {
        return null;
    }

    return <Widget />;
};
